import React, { memo, RefObject } from 'react';

import PlayIcon from 'assets/images/play-fill.svg';
import ButtonLink from 'components/button-link';
import Image from 'components/image';
import './styles.scss';

interface IPlayButton {
  innerRef: RefObject<HTMLButtonElement>;
  onClick: () => void;
}

const PlayButton: React.FC<IPlayButton> = ({ innerRef, onClick }) => {
  return (
    <ButtonLink innerRef={innerRef} className="play-btn" onClick={onClick} >
      <div className="background" />
      <Image src={PlayIcon} />
    </ButtonLink>
  );
};

export default memo(PlayButton);
